import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  DoCheck,
  AfterViewInit,
  Inject,
  Input,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  NgForm,
  Validators,
  FormControl,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { beatBlipSubscriptionConsts } from "src/app/consts/beatBlipSubscriptionConsts";
import { UserMgmtService } from "src/app/_services/user-mgmt.service";
import { HomeService } from "src/app/_services/home.service";
import { UserService } from "src/app/_services/user.service";
import { ProjectService } from "src/app/_services/project.service";
import { UserRestrictions } from "../../_models/userRestriction";
import { UserTab } from "../../_models/UserTab";
import { CookieService } from "ngx-cookie-service";
import { ActivatedRoute, Router } from "@angular/router";
import { MustMatch } from "../../_helpers/must-match.validator";
import { DOCUMENT } from "@angular/common";
import { ConfirmationDialogService } from "src/app/test/test-step/confirmation-dialog.service";
import { Subscription } from "rxjs";
import { ProjectData } from "src/app/_models/project-data";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { TestService } from "src/app/_services/test.service";
import * as CryptoJS from 'crypto-js';
import {EncryptionService} from "src/app/_services/encryption.service"
import { right } from "@popperjs/core";
@Component({
  selector: "app-topnavbar",
  templateUrl: "./topnavbar.component.html",
  styleUrls: ["./topnavbar.component.scss"],
})
export class TopnavbarComponent implements OnInit, DoCheck, AfterViewInit {

  @ViewChild("cancelmodal", null) cancelmodal: ElementRef;
  @ViewChild("closemodal", null) closemodal: ElementRef;
  @ViewChild("formDirective", null) private formDirective: NgForm;
  @ViewChild("cancelmodalforlocatorModule", null)
  cancelmodalforlocatorModule: ElementRef;
  @ViewChild("cancelmodalScreen", null) cancelmodalScreen: ElementRef;
  @ViewChild("cancelImportLocatorScreen", null)
  cancelImportLocatorScreen: ElementRef;
  @ViewChild("cancelImportTestDataScreen", null)
  cancelImportTestDataScreen: ElementRef;
  @ViewChild("cancelLocalizationDataScreen", null)
  cancelLocalizationDataScreen: ElementRef;
  @ViewChild("cancelSeleniumDataScreen", null)
  cancelSeleniumDataScreen: ElementRef;
  @ViewChild("menu", null)
  menuButton: ElementRef;

  headerOptions: any;

  projectCreateForm: UntypedFormGroup;
  locatorCreateForm: UntypedFormGroup;
   currentUser: any;
  private userType: String;

  private userData: any;
  private changePasswordForm: UntypedFormGroup;
  private userAddForm: UntypedFormGroup;
  private masterusers: [] = [];
  private inserted: boolean = false;
  private statusData: any = [];
  private selectCheckBox: any = [];
  private isVisible: boolean = false;
  private isAdduser: boolean = false;
  private selectedTabIndex: Number = 0;
  private selectedCustomer: any;
  loading = false;
  submitted = false;
  login = false;
  userAddFormSubmitted = false;

  fileDownLoadUrl: any;
  private isAdmin: boolean = false;
  private isRoot: boolean = false;
  private isNormalUser: boolean = false;
  private restrictionUser = new UserRestrictions();
  private userCustomerProfile: any;
  messages: any;
  subscription: Subscription;
  subscription2: Subscription;
  projectId: any;
  screenCreateForm: UntypedFormGroup;
  options: string[] = [
    "Web Application",
    "Mobile App",
    "RESTful Web Services",
    "Desktop Application",
    "TCP / IP Server",
    "Hybrid",
  ];
  projectType = "Web Application";
  allProjectName: ProjectData[];
  newProjectData: any;
  dataForModuleCreateForm: any;
  locatorModuleData: any;
  locatorEntryMap = {};
  locatorCommentMap = {};
  locatorFileName: string = "";
  testDataFile;
  aboutUsDetails: any;
  testDataFileName: string;
  localizationFileName: string;
  localizationFile;
  seleniumFileName: string;
  seleniumFile;
  url: string;
  showSeleniumModal: boolean = false;
  selenuimTestId: string;
  currenturl: String = location.href;
  projectResetName: string = undefined;
  recorderUrl: string;
  huloopAgentUrl: string;
  huloopAgentUrlConsole: string;
  huloopAgentUrlMac: string;
  desktopRecorderUrl: string;
  mobileRecorderAndroidUrl: string;
  mobileRecorderIosUrl: string;

  isModuleSelected: boolean;
  isLocatorModuleSelected: boolean;
  selectedModuleData: any;
  selectedLocatorModuleData: any;
  isTestSuiteSelected: any;
  isLocatorTestSuiteSelected : boolean;

  globalSearch: string;
  matchedSuggestions : any = [];
  showSuggestion : boolean = false;
  searchSuggestions : any = [];
  searchResult : any = [];
  showSearchResult : boolean = false;
  firstName: string;
  huloopAgentUrlMacConsole: string;
  dycData: any;
  version: string;
  desktopDriverUrl: string ;
  demoUrl: string;


  constructor(
    private userService: UserService,
    private projectService: ProjectService,
    private formBuilder: UntypedFormBuilder,
    private usermgmt: UserMgmtService,
    private toastrService: ToastrService,
    private cookieService: CookieService,
    private router: Router,
    private route: ActivatedRoute,
    private project: ProjectService,
    private confirmationDialogService: ConfirmationDialogService,
    private http: HttpClient,
    private testCase: TestService,
    private homeService: HomeService,
    private encDycServices: EncryptionService,
    @Inject(DOCUMENT) private document: Document,
    private elRef: ElementRef
  ) {
    // let obj = JSON.parse(localStorage.getItem("selectedProject"));
    //      this.projectId = obj.id;
    // this.version = beatBlipSubscriptionConsts.version;
    this.subscription = this.project.getMessage().subscribe((message) => {
      if (message) {
        this.projectId = message["text"];
        let obj = JSON.parse(localStorage.getItem("selectedProject"));
         this.projectId = obj.id;
        //console.log(this.projectId);
      } else {
        // clear messages when empty message received
        this.messages = [];
      }
    });
    
    let that =  this;
    // window.addEventListener('click', function(e: any){
    //   if (document.getElementById('hl-megamenuWrapper').contains(e.target) || e.target.id == 'menuButton' || e.target.id == 'menuImage' || e.target.id == 'menuText'){
    //     return
    //   }
    //   else
    //   {
    //     let element = document.getElementById("hl-megamenuWrapper");
    //     if(element.classList.contains("menushow"))
    //     {
    //       that.toggleMenu();
    //     }
    //   }
    // })
  }
  toggleMenu(){
    $('.hl-megamenuWrapper').toggleClass('menushow');
  }
  getUserDetail(){
    this.userService.getUser().subscribe((data) => {
        this.currentUser = data;
        localStorage.setItem("currentUser", JSON.stringify(data));
        this.homeService.getHeaderOptions().subscribe((res)=> { 
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
         
          let name =  this.currentUser.name.split(" ");
          this.firstName = name[0];
          this.closeNav();
          setTimeout(()=>
          {
            this.headerOptions = res;
            if (this.headerOptions?.showSearch) {
              this.projectService.getSearchSuggestions().subscribe((res) => {
                this.searchSuggestions = res['suggestion'];
              })
            } else {
              this.homeService.searchString.next(null);
            }
            this.projectId = this.headerOptions.data ? this.headerOptions.data.projectId : undefined;
          }, 0)
    
        })
      });
}
  ngOnInit() {
    // custom validator to check that two fields match
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // //console.log( this.router.routeReuseStrategy.shouldReuseRoute = () => false);

    //change header options
    if(!JSON.parse(localStorage.getItem('currentUser'))){
      this.getUserDetail();
    }
  else{
    this.homeService.getHeaderOptions().subscribe((res)=> { 
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
     
      let name =  this.currentUser.name.split(" ");
      this.firstName = name[0];
      this.closeNav();
      setTimeout(()=>
      {
        this.headerOptions = res;
        if (this.headerOptions?.showSearch) {
          this.projectService.getSearchSuggestions().subscribe((res) => {
            this.searchSuggestions = res['suggestion'];
          })
        } else {
          this.homeService.searchString.next(null);
        }
        this.projectId = this.headerOptions.data ? this.headerOptions.data.projectId : undefined;
      }, 0)

    })
  }

    this.homeService.searchString.subscribe((res)=>
    {
      this.globalSearch = res;
    })

    this.loadJQuery();
    this.accordion();
  
    this.url = environment.baseUrl;
    this.demoUrl = this.url; 
    // if(this.url.includes('dev-v5.huloop.ai')){
    //  this.demoUrl = this.url 
    // }
    // else{
    //   this.demoUrl = 'https://demo.huloop.ai:451'
    // }
    this.recorderUrl = this.demoUrl+'/zips/HuLoopRecorder.zip';
    this.huloopAgentUrl = this.demoUrl +'/zips/HuLoop.zip';
    this.huloopAgentUrlConsole = this.demoUrl+'/zips/HuLoopConsole.zip';
    this.huloopAgentUrlMac = this.demoUrl+'/zips/HuLoop-MAC.zip';
    this.huloopAgentUrlMacConsole = this.demoUrl+'/zips/HuLoopConsole-MAC.zip';
    this.desktopRecorderUrl = this.demoUrl+'/zips/WindowsDesktopRecorder.zip';
    this.mobileRecorderAndroidUrl  = this.demoUrl+'/zips/MobileRecorder_Android.zip';
    this.mobileRecorderIosUrl  = this.demoUrl+'/zips/MobileRecorder_iOS.zip';
    this.desktopDriverUrl = this.demoUrl+'/zips/HuLoopDesktopDriver.zip';

    // this.loadFormData();
    this.statusData.push("Active", "Inactive");
    this.selectCheckBox.push("YES", "NO");
  
    if(localStorage.getItem("selectedProject")){
      let obj = JSON.parse(localStorage.getItem("selectedProject"));
      this.projectId = obj.id;
    }
    // if(localStorage.getItem('currentUser')) {
    //   this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    //   if(localStorage.getItem('userType')) {
    //     this.userType = localStorage.getItem('userType');
    //   }
    // } else {
    this.loadFormData();
    this.projectService.setUserDetails(JSON.parse(localStorage.getItem('currentUser')));
    this.projectService.getUserDetails().subscribe((data) => {
      localStorage.setItem("currentUser", JSON.stringify(data)); 
    });
    
    var loginSubscriptionData = this.cookieService.get("loginSubscriptionData");

    if(loginSubscriptionData && loginSubscriptionData.length>0){
      var userLoginDetails =JSON.parse(loginSubscriptionData);
      //console.log("", userLoginDetails)
      if (userLoginDetails) {
        this.version=userLoginDetails.version;
        this.login = true;
      }
    }

    // this.project.isModuleSelected.subscribe((res)=>
    // {
    //   console.log(res);
    //   this.isModuleSelected = res;
    // })

    this.project.isLocatorModuleSelected.subscribe((res)=>
    {
      console.log(res);
      this.isLocatorModuleSelected = res;
    })

    // this.project.selectedModuleData.subscribe((res)=>
    // {
    //   console.log(res);
    //   this.selectedModuleData = res;
    // })

    this.project.selectedLocatorModuleData.subscribe((res)=>
    {
      console.log(res);
      this.selectedLocatorModuleData = res;
    })

    this.project.isTestSuiteSelected.subscribe((res)=>
    {
        this.isTestSuiteSelected = res;
    })

    this.project.isLocatorTestSuiteSelected.subscribe((res)=>
    {
        this.isLocatorTestSuiteSelected = res;
    })

 }
   
 loadJQuery()
 {
  $('.hl-cardBtnHead').click(function () {
    $('.hl-cardBtnHead').removeClass('active');
    $(this).addClass('active');
  });

  $('.hl-cardBtnHead').click(function () {
    $(this).parent().removeClass('openTooltip');
    $(this).parent().toggleClass('hl-showv1');
    // $('.hl-cardBtnWrapper').toggleClass('hl-showv1');
  });
  
  $('.hl-cardBtncontentEnter span.questionmark').click(function () {
    //  $('.hl-cardBtncontentEnter').toggleClass('text-show');
    $(this).parent().toggleClass('text-show');
    $(this).parent().children('.hl-EnterText').slideToggle(1000);
    // $('.hl-EnterText').slideToggle(1000);
  });

 }

openNav() {
    document.getElementById("mySidenav").style.width = "331px";
  }
  
closeNav() {
    document.getElementById("mySidenav").style.width = "0px";
  }

 accordion(){
  $(document).ready(function(){
    $('.accordion-list > li > .answer').hide();
      
    $('.accordion-list > li').click(function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active").find(".answer").slideUp();
      } else {
        $(".accordion-list > li.active .answer").slideUp();
        $(".accordion-list > li.active").removeClass("active");
        $(this).addClass("active").find(".answer").slideDown();
      }
      return false;
    });
    
  });
 }

  isCanViewUser = function () {
    return this.canViewUser();
  };

  loadFormData() {
    this.changePasswordForm = this.formBuilder.group(
      {
        password: ["", [Validators.required, Validators.minLength(6)]],
        newPassword: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: [MustMatch("newPassword", "confirmPassword")],
      }
    );

    this.userAddForm = this.formBuilder.group({
      name: [{ value: "" }, Validators.required],
      email: [
        { value: "", disabled: !this.isAdduser },
        [Validators.required, Validators.email],
      ],
      password: [null, Validators.required],
      phoneNumber: [null, Validators.required],
      status: ["Active", Validators.required],
    });

    this.projectCreateForm = this.formBuilder.group({
      projectName: [
        null,
        [
          Validators.required,
          Validators.maxLength(250),
          Validators.pattern(/^((?!\s{2,}).)*$/),
        ],
      ],
      projectType: ["Web Application"],
    });

    this.initLocatorCreateForm();
    this.initScreenCreateForm();
  }

  initLocatorCreateForm() {
    this.locatorCreateForm = this.formBuilder.group({
      locatorName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
  }

  initScreenCreateForm() {
    this.screenCreateForm = this.formBuilder.group({
      screenName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
    this.locatorFileName = "";

    if(this.isLocatorTestSuiteSelected)
    {
      this.toastrService.clear();
      this.toastrService.warning("please select a project or a test module");
    }
  }

  updatePasswordForm() {
    this.submitted = false;
    this.changePasswordForm.reset();
  }

  get f() {
    return this.changePasswordForm.controls;
  }

  get userD() {
    return this.userAddForm.controls;
  }

  onFormSubmit() {
    this.userAddFormSubmitted = true;
    if (this.userAddForm.invalid) {
      return;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.changePasswordForm.invalid) {
      return;
    }
    this.loading = true;
    var cancelObj = this.cancelmodal;
    //console.log(cancelObj)
    const result = this.userService.changePassword(
      this.changePasswordForm.value
    );
    this.cancelmodal.nativeElement.click();
    this.changePasswordForm.reset();
  }

  loadUser() {
    this.getProjectListData();
    this.selectedTabIndex = 0;
    this.isVisible = false;
    if (this.formDirective) {
      this.formDirective.reset();
      this.formDirective.resetForm();
    }
    // this.usermgmt.loadUserData().subscribe((data) => {
    //   //  alert(JSON.stringify(data));

    //   this.masterusers = data["masteruser"];
    // });
  }

  // checkUserType() {
  //   if (this.userType === 'Admin') {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  checkUserData() {
    if (!this.masterusers && this.masterusers.length > 0) {
      return false;
    }
    return true;
  }

  isCanEditUser(user) {
    var isAdmin =
      user.userRole.roleName === beatBlipSubscriptionConsts.TYPE_ADMIN;
    var isLoggedInUser = user.customer.id === this.currentUser.id;
    return this.canEditUser() && !isAdmin && !isLoggedInUser;
  }

  isCanEditProjectPermission(user) {
    var isAdmin =
      user.userRole.roleName === beatBlipSubscriptionConsts.TYPE_ADMIN;
    var isLoggedInUser = user.customer.id === this.currentUser.id;
    return this.canEditUser() && !isAdmin && !isLoggedInUser;
  }

  canCreateUser() {
    if (this.currentUser && this.userCustomerProfile) {
      var privilegeArr = this.userCustomerProfile.privilegeMap.entry;
      for (var index = 0; index < privilegeArr.length; index++) {
        var privilege = privilegeArr[index];
        if (privilege.key === "USER") {
          return privilege.value.createPrivilege.value === "YES" ? true : false;
        }
      }
    }
    return true;
  }

  canEditUser() {
    if (this.currentUser && this.userCustomerProfile) {
      var privilegeArr = this.userCustomerProfile.privilegeMap.entry;
      for (var index = 0; index < privilegeArr.length; index++) {
        var privilege = privilegeArr[index];
        if (privilege.key === "USER") {
          return privilege.value.editPrivilege.value === "YES" ? true : false;
        }
      }
    }
    return true;
  }

  canViewUser() {
    if (this.currentUser && this.userCustomerProfile) {
      var privilegeArr = this.userCustomerProfile.privilegeMap.entry;
      for (var index = 0; index < privilegeArr.length; index++) {
        var privilege = privilegeArr[index];
        if (privilege.key === "USER") {
          return privilege.value.viewPrivilege.value === "YES" ? true : false;
        }
      }
    }
    return true;
  }

  loadProfile(index) {
    this.selectedTabIndex = 1;
    this.selectedCustomer = this.masterusers[index];
  }

  saveProfile() {
    let copy = Object.assign({}, this.selectedCustomer);
    var updatedCustomer = this.updateSelectedCustomerProfile(copy);
    // alert(JSON.stringify(updatedCustomer));
    this.usermgmt.editCustomerProfile(updatedCustomer).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.info("User updated successfully");
      this.loadUser();
      // alert(JSON.stringify(data));
    });
  }

  updateSelectedCustomerProfile(updatedUser) {
    for (
      var i = 0;
      i < updatedUser.userRole.CustomerProfile.privilegeMap.entry.length;
      i++
    ) {
      if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .viewPrivilege.value === true
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.viewPrivilege.value = "YES";
      } else if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .viewPrivilege.value === false
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.viewPrivilege.value = "NO";
      }

      if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .createPrivilege.value === true
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.createPrivilege.value = "YES";
      } else if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .createPrivilege.value === false
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.createPrivilege.value = "NO";
      }

      if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .editPrivilege.value === true
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.editPrivilege.value = "YES";
      } else if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .editPrivilege.value === false
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.editPrivilege.value = "NO";
      }

      if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .deletePrivilege.value === true
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.deletePrivilege.value = "YES";
      } else if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .deletePrivilege.value === false
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.deletePrivilege.value = "NO";
      }

      if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .executePrivilege.value === true
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.executePrivilege.value = "YES";
      } else if (
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[i].value
          .executePrivilege.value === false
      ) {
        updatedUser.userRole.CustomerProfile.privilegeMap.entry[
          i
        ].value.executePrivilege.value = "NO";
      }
    }
    // updatedUser.userRole.CustomerProfile.privilegeMap.entry.forEach(element => {

    //   });
    return updatedUser;
  }

  tabClick(clickEvent: any) {
    // const clickedTabIndex = this.getTabIndex(clickEvent.toElement.innerText);
    // if (clickedTabIndex === -1) {
    //   //this.selectedTabIndex = 2;
    //   return;
    // }
    // // if (!(this.selectedTabIndex === clickedTabIndex)) {
    // this.loadUser();
    // this.selectedTabIndex = clickedTabIndex;
    //}
  }

  tabs: any = [];
  projects: any = [];
  userSelected: any;
  projectSelected: any;
  projectSelectedIndex: any;
  tabHeading: string;

  showUserRestriction(user: any) {
    if (this.projects && this.projects.length > 0) {
      const tabUser = new UserTab();
      tabUser.user = user;
      tabUser.heading = user.name;
      this.tabHeading = user.name;
      tabUser.active = true;

      if (this.tabs.length >= 1) {
        this.tabs.splice(0, 1);
      }
      this.selectedTabIndex = 2;
      this.tabs.push(tabUser);
      this.userSelected = tabUser.user;
      this.showProjectRestriction(0);
    } else {
      this.toastrService.clear();
      this.toastrService.info(beatBlipSubscriptionConsts.NO_PROJECT_FOR_USER);
    }
  }

  showProjectRestriction(index: any) {
    this.projectSelectedIndex = index;
    this.projectSelected = this.projects[this.projectSelectedIndex];
    //var userRestriction = {};
    //restrictionUser = userRestriction;
    this.restrictionUser = new UserRestrictions();
    this.restrictionUser.userId = this.userSelected.id;
    this.restrictionUser.entityId = this.projectSelected.id;
    this.restrictionUser.entityType = "PROJECT";
    this.usermgmt
      .getUserRestrictionsForEntity(
        this.userSelected.id,
        this.projectSelected.id
      )
      .subscribe((data) => {
        if (data) {
          this.restrictionUser.id = data["id"];
          // this.restrictionUser.id = data.id;
          this.restrictionUser.userId = data["userId"];
          this.restrictionUser.entityId = data["entityId"];
          this.restrictionUser.entityType = data["entityType"];
          this.restrictionUser.view = data["view"];
          this.restrictionUser.edit = data["edit"];
          this.restrictionUser.delete = data["delete"];
        }
        //  alert(JSON.stringify(data));
      });
  }

  saveUserRestriction() {
    this.usermgmt
      .createOrUpdateUserRestriction(
        this.userSelected.id,
        this.projectSelected.id,
        this.restrictionUser
      )
      .subscribe((data) => {
        if (data) {
          this.restrictionUser.id = data["id"];
          // this.restrictionUser.id = data.id;
          this.restrictionUser.userId = data["userId"];
          this.restrictionUser.entityId = data["entityId"];
          this.restrictionUser.entityType = data["entityType"];
          this.restrictionUser.view = data["view"];
          this.restrictionUser.edit = data["edit"];
          this.restrictionUser.delete = data["delete"];
          this.toastrService.clear();
          this.toastrService.info(
            "User project permission updated successfully"
          );
        }
      });
  }

  getFlagForAccess(actual, expected) {
    if (actual === "view") {
      return this.restrictionUser.view === expected;
    } else if (actual === "delete") {
      return this.restrictionUser.delete === expected;
    } else if (actual === "edit") {
      return this.restrictionUser.edit === expected;
    }
  }

  setAccessFlag(key, flag) {
    if (key === "view") {
      this.restrictionUser.view = flag;
    } else if (key === "delete") {
      this.restrictionUser.delete = flag;
    } else if (key === "edit") {
      this.restrictionUser.edit = flag;
    }
  }

  removeTab(index) {
    this.tabs.splice(index, 1);
    this.projectSelected = undefined;
  }

  getTabIndex(tabName: string): number {
    switch (tabName) {
      case "User Details":
        return 0;
      default:
        return -1; // return -1 if clicked text is not a tab label text
    }
  }

  addUser() {
    this.resetAccountManagementForm();
    this.userD.email.enable();
    this.userD.name.enable();
    this.userD.password.setValidators([
      Validators.required,
      Validators.minLength(5),
    ]);
    this.userD.email.updateValueAndValidity();
    this.userD.name.updateValueAndValidity();
    //this.userD.password.updateValueAndValidity();

    this.isAdduser = true;
    this.isVisible = true;
    this.userData = {};
    this.userData.status = "Active";
  }

  editFormOpen(index) {
    this.isVisible = true;
    this.isAdduser = false;
    this.userD.email.disable();
    this.userD.password.clearValidators();

    this.userD.email.updateValueAndValidity();
    this.userD.name.updateValueAndValidity();
    this.userD.password.updateValueAndValidity();
    var masterSelectedUser = this.masterusers[index];
    this.userData = masterSelectedUser["customer"];
    // //console.log(JSON.stringify(this.userData));
  }

  isCanCreateUser() {
    return this.canCreateUser();
  }

  getProjectListData() {
    this.usermgmt.getProjectInfo().subscribe((data) => {
      this.projects = data["project"];
      ////console.log(JSON.stringify(this.projects));
    });
  }

  updateUser() {
    this.userAddFormSubmitted = true;
    if (this.userData) {
      var validationFlag = this.userDataValidation();
      if (validationFlag) {
        if (this.userData.id) {
          this.usermgmt.editCustomer(this.userData).subscribe((data) => {
            this.isVisible = false;
            this.userData = {};
            this.toastrService.clear();
            this.toastrService.info("User updated successfully");
            this.loadUser();
          });
        } else {
          this.usermgmt.createCustomer(this.userData).subscribe((data) => {
            this.isVisible = false;
            this.userData = {};
            this.loadUser();
            this.toastrService.clear();
            this.toastrService.info("User created successfully");
            this.resetAccountManagementForm();
          });

          //console.log("In Save-------------" + JSON.stringify(this.userData));
        }
      }
    } else {
      this.toastrService.clear();
      this.toastrService.warning("No User data found for update");
    }
  }
  resetAccountManagementForm() {
    this.userAddFormSubmitted = false;
    this.userAddForm.reset();
  }
  checkCokkies($event) {
    if (!this.cookieService.get("loginSubscriptionData")) {
      this.router.navigate(["/login"]);
      $event.preventDefault();
      $event.stopPropagation();
    }
  }

  userDataValidation() {
    if (!this.userData.name || !this.userData.email || !this.userData.phone) {
      if (this.isAdduser) {
        if (!this.userData.password) {
          this.toastrService.clear();
          this.toastrService.warning("Please enter all required fields");
          return false;
        }
      }
      this.toastrService.clear();
      this.toastrService.warning("Please enter all required fields");
      return false;
    }
    return true;
  }

  getApiAccessToken() {
    this.userService.getApiAcessToken();
    return true;
  }

  createProjectForm() {
    this.projectCreateForm = this.formBuilder.group({
      projectName: ["", Validators.required],
      projectType: ["", Validators.required],
    });
  }
  get f1() {
    return this.projectCreateForm.controls;
  }

  updateAsEnum(type) {
    var pType = "WEB";
    if (type) {
      if (type === "Web Application") {
        pType = "WEB";
      } else if (type === "Mobile App") {
        pType = "MOBILE";
      } else if (type === "RESTful Web Services") {
        pType = "REST";
      } else if (type === "Desktop Application") {
        pType = "DESKTOP";
      } else if (type === "TCP / IP Server") {
        pType = "SERVER";
      } else if (type === "Hybrid") {
        pType = "MIXED";
      }
    }
    return pType;
  }
  onCreate() {
    this.submitted = true;

    if (this.projectCreateForm.invalid) {
      return;
    }
    var objFormval = this.projectCreateForm.value;
    //console.log(objFormval);
    if (objFormval["projectType"] == "") {
      objFormval["projectType"] = "WEB";
    }
    objFormval["projectType"] = this.updateAsEnum(objFormval["projectType"]);
    //console.log(objFormval);
    var close = this.closemodal;

    this.projectService.addDefaultProject(objFormval).subscribe((data) => {
      if (data) {

        //call suggestion api
        // this.projectService.loadSuggestion.next(true);
        //console.log(data);
        this.newProjectData = data;
        //console.log(this.newProjectData.id)
        //  this.project.sendMessage(data['id']);
        this.http
          .get(
            this.url +
              "/HuLoopRest/huloop/" +
              "test/all/" +
              this.newProjectData.id
          )
          .subscribe((data) => {
            //console.log(data);
            var moduleId = data["testSuiteDirData"][0].id;
            var suitId = data["testSuiteFileData"][0].id;

            //console.log(moduleId,suitId);

            // this.router.navigate(['/test/TestSuit/' + this.newProjectData.id + '/' + suitId]);
            // this.project.shareProjectId(this.newProjectData.id);
          });
        this.router.navigate([
          "/report/project-report/" + this.newProjectData.id,
        ]);
        //console.log('cancel>>', this.closemodal.nativeElement.click())
        this.project.getAllProjects().subscribe((data) => {
          if (data) {
            //console.log(data);

            this.allProjectName = data;
            //console.log('cancel>>', this.closemodal.nativeElement.click())
            //  this.sendMessage(this.allProjectName);

            this.projectCreateForm = this.formBuilder.group({
              projectName: [null, Validators.required],
              projectType: ["Web Application"],
            });
            this.project.sendProjectData(this.allProjectName);
            this.toastrService.clear();
            this.toastrService.success(" Project Added successfully");
          }
        });
        this.closemodal.nativeElement.click();
        // this.refreshPage();
      }
    });
  }

  onReset() {
    this.projectCreateForm.reset();
  }

  onReset1() {
    this.changePasswordForm = this.formBuilder.group({
      password: ["", [Validators.required, Validators.minLength(6)]],
      newPassword: ["", [Validators.required, Validators.minLength(6)]],
      confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
    });
  }

  onReset2() {
    this.projectCreateForm = this.formBuilder.group({
      projectName: [
        null,
        [
          Validators.required,
          Validators.maxLength(250),
          Validators.pattern(/^((?!\s{2,}).)*$/),
        ],
      ],
      projectType: ["Web Application"],
    });
  }

  sendMessage(all): void {
    // send message to subscribers via observable subject
    this.project.sendMessage(all);
  }

  onCreateLocators() {
    this.submitted = true;
    if (this.locatorCreateForm.invalid) {
      return;
    }
    var objFormval = this.locatorCreateForm.value;
    var Objval = {
      name: objFormval.locatorName,
      projectId: this.projectId,
    };
    //console.log(Objval);
    // var cancelObj = this.cancelmodal;
    this.projectService.addLocator(Objval).subscribe((data) => {
      if (data) {
        this.locatorModuleData = data;
        //console.log(this.locatorModuleData.id)
        var ObjvalForDefault = {
          name: objFormval.locatorName + "Screen",
          projectId: this.projectId,
          parentLocatorId: this.locatorModuleData.id,
        };
        //console.log(Objval);
        // var cancelObj = this.cancelmodal;
        this.projectService.addScreen(ObjvalForDefault).subscribe((data) => {
          if (data) {
            this.cancelmodalforlocatorModule.nativeElement.click();

            this.toastrService.clear();
            this.toastrService.success(
              " New locator process group Added successfully"
            );
            //console.log("Locator data", data);
            this.project.sendLocatorData(this.projectId);
          }
        });
      }
    });
  }
  onCreateScreen() {
    this.submitted = true;
    if (this.screenCreateForm.invalid) {
      return;
    }
    var objFormval = this.screenCreateForm.value;
    var Objval = {
      name: objFormval.screenName,
      projectId: this.projectId,
    };

    if(this.isLocatorModuleSelected)
    {
          Objval['parentLocatorId'] = this.selectedLocatorModuleData.moduleData.name;
    }

    //console.log(Objval);
    // var cancelObj = this.cancelmodal;
    this.projectService.addScreen(Objval).subscribe((data) => {
      if (data) {
        this.cancelmodalScreen.nativeElement.click(); //;
        this.toastrService.clear();
        this.toastrService.success(" New Screen Added successfully");
        // //console.log("Locator data",data);
        // this.refreshPage();
        this.project.sendLocatorData(this.projectId);
      }
    });
  }

  uploadLocator(event: any) {
    let file = event.target.files[0];
    let extension = file.type;
    //console.log(file)
    this.locatorFileName = file.name.substring(0, file.name.lastIndexOf("."));
    var fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = (e) => {
      let contentList = fileReader.result.toString().split("\n");
      //console.log(contentList);

      var locatorData = new Array();
      var commentData = new Array();

      var comment = undefined;

      contentList.forEach((data) => {
        data = data.trim();
        if (data !== null && data.length > 0) {
          if (data.indexOf("#") === 0) {
            comment = data.substring(1);
          }
          var entry = {};
          var commentEntry = {};
          if ("csv" === extension) {
            entry["key"] = data
              .substring(0, data.indexOf(","))
              .replace(/["]+/g, "");
            entry["value"] = data
              .substring(data.indexOf(",") + 1)
              .replace(/["]+/g, "");
          } else {
            entry["key"] = data.substring(0, data.indexOf("="));
            entry["value"] = data.substring(data.indexOf("=") + 1);
          }
          commentEntry["key"] = entry["key"];
          if (comment != undefined) {
            commentEntry["value"] = comment;
          }
          commentData.push(commentEntry);
          comment = undefined;
          locatorData.push(entry);
        }
      });

      //console.log(locatorData);
      //console.log(commentData);
      this.locatorEntryMap["entry"] = locatorData;
      this.locatorCommentMap["entry"] = commentData;
    };
  }

  resetImportLocator() {
    this.locatorFileName = "";
    this.locatorCommentMap = {};
    this.locatorEntryMap = {};
  }

  onImportLocators() {
    if (
      this.locatorFileName != "" &&
      this.locatorCommentMap != {} &&
      this.locatorEntryMap != {}
    ) {
      let obj = {
        projectId: this.projectId,
        name: this.locatorFileName,
        locatorEntryMap: this.locatorEntryMap,
        locatorCommentMap: this.locatorCommentMap,
      };

      this.project.addScreen(obj).subscribe((res) => {
        //console.log(res);
        this.toastrService.success("Screen imported successfully");
        this.cancelImportLocatorScreen.nativeElement.click();
        this.project.sendLocatorData(this.projectId);
        this.resetImportLocator();
      });
    }
  }

  uploadTestData(event: any) {
    this.testDataFile = event.target.files[0];
    this.testDataFileName = this.testDataFile.name.substring(
      0,
      this.testDataFile.name.lastIndexOf(".")
    );
  }

  onImportTestData() {
    if (this.testDataFile == undefined) {
      return;
    }
    let testDataId;
    let testDataName;
    //console.log("inside upload");
    var fd = new FormData();
    fd.append("file", this.testDataFile);

    this.http
      .post(
        this.url +
          "/HuLoopRest/huloop/textData/upload/" +
          this.projectId +
          "/default/" +
          testDataId +
          "/" +
          testDataName,
        fd
      )
      .subscribe((res) => {
        this.resetTestDataModel();
        this.toastrService.success("Test data uploaded successfully");
        this.projectService.sendTestData(res);
        this.cancelImportTestDataScreen.nativeElement.click();
      });
  }

  onImportLocalizationFile() {
    if (this.localizationFile == undefined) {
      return;
    }

    var fd = new FormData();
    fd.append("file", this.localizationFile);

    this.http
      .post(
        this.url +
          "/HuLoopRest/huloop/projectCultureImport/uploadCulture/" +
          this.projectId,
        fd
      )
      .subscribe((res) => {
        this.toastrService.success("Localization file uploaded successfully");
        this.cancelLocalizationDataScreen.nativeElement.click();
      });
  }

  onImportSeleniumFile() {
    if (this.seleniumFile == undefined) {
      return;
    }

    var fd = new FormData();
    fd.append("file", this.seleniumFile);

    this.http
      .post(
        this.url +
          "/HuLoopRest/huloop/testImport/uploadSelenium/" +
          this.projectId +
          "/" +
          this.selenuimTestId,
        fd
      )
      .subscribe((res) => {
        this.toastrService.success("  Selenium file uploaded successfully");
        this.cancelSeleniumDataScreen.nativeElement.click();
        this.projectService.sendTestData(res);
      });
  }

  refreshPage() {
    this.document.defaultView.location.reload();
  }
  ngDoCheck() {
    // //console.log("do check")
  }
  ngAfterViewInit() {
    // //console.log("after view init")
  }
  //private confirmationDialogService: ConfirmationDialogService,
  importProject() {
    this.confirmationDialogService
      .openImportPopup("import")
      .afterClosed()
      .subscribe((res) => {
        //console.log('import');
      });
  }

  openManageTestData() {
    //console.log(this.projectId);
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project');
    } else if (this.projectId) {
      this.router.navigate(["/data/manage-test-data/" + this.projectId]);

      // //console.log('openManageTestData()')
    }
  }

  openConsoleManagement() {
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project')
    } else if (this.projectId) {
      this.closeNav();
      this.router.navigate(["/manageConsoleExecution/" + this.projectId]);
    }
  }

  openManageSqlData() {
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project')
    } else if (this.projectId) {
      this.router.navigate(["/data/manage-sql-script/" + this.projectId]);
    }
  }

  openManageCultureData() {
    if (this.projectId === undefined) {
      this.toastrService.warning("please select a project first");
    } else if (this.projectId) {
      // this.router.navigate(['/data-management/' +this.projectId]);
    }
  }

  openManageJavascript() {
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project')
    } else if (this.projectId) {
      this.router.navigate(["/data/manage-javascript/" + this.projectId]);
    }
  }
  openManageBugs() {
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project')
    } else if (this.projectId) {
      this.router.navigate(["/data/manage-bug/" + this.projectId]);
    }
  }
  openManageAutoITScripts() {
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project')
    } else if (this.projectId) {
      this.router.navigate(["/data/manage-auto-it/" + this.projectId]);
    }
  }
  openManagePythonScripts() {
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project')
    } else if (this.projectId) {
      this.router.navigate(["/data/manage-python-script/" + this.projectId]);
    }
  }

  openRunManagement() {
    if (this.projectId === undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please Select a project')
    } else if (this.projectId) {
      this.router.navigate(["/test/run-management/" + this.projectId]);
    }
  }
  openTestReport(value) {
    this.menuButton.nativeElement.click();
    this.router.navigate([
      "/report/testReport/" + this.projectId + "/" + value,
    ]);
  }
  navigateToHistory() {
    this.router.navigate(["/test/test-history/" + this.projectId]);
  }
  openLocatorModel() {}

  openConsoleReport() {
    var flag = "No";
    if (this.projectId === null) {
      this.toastrService.clear();
      this.toastrService.warning("Please select a project.");
    }
    if (flag === "No") {
      this.toastrService.clear();
      this.toastrService.warning("You have no active execution.");
    } else {
      this.toastrService.clear();
      this.toastrService.warning("You have no active execution.");
    }
  }

  tagReport() {
    this.router.navigate(["/report/projectTagReport/" + this.projectId]);
  }

  onLocators(id) {
    //console.log('locators');
    this.project.loadLocator(id);
  }
  openTestModel() {
    this.project.getProjectById(this.projectId).subscribe((data) => {
      this.dataForModuleCreateForm = data;
      //console.log(this.dataForModuleCreateForm);
      this.confirmationDialogService
        .openParentModulePopUp(this.dataForModuleCreateForm)
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.project.sendProjectData(this.allProjectName);
          }
        });
    });
  }
  openTestSuite() {
    if(this.isTestSuiteSelected)
    {
        this.toastrService.clear();
        this.toastrService.warning("Please select a project or a test module");
        return;
    }

    this.project.getProjectById(this.projectId).subscribe((data) => {
      this.dataForModuleCreateForm = data;
      //console.log(this.dataForModuleCreateForm);
      this.confirmationDialogService
        .openAddtestSuitPopUp(this.dataForModuleCreateForm, "Add")
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.project.sendProjectData(this.allProjectName);
            // this.project.loadSuggestion.next(true);
          }
        });
    });
  }

  // reloadLicense() {
  //   this.projectService.reloadLicense().subscribe((res) => {
  //     this.toastrService.clear();
  //     this.toastrService.success("License data updated successfully");
  //     this.getSettingData();
  //   });
  // }

  getSettingData() {
    this.projectService.getSettingData().subscribe((res) => {
      //console.log(res);
    });
  }

  aboutBeatBlip() {
    this.projectService.aboutBeatBlip().subscribe((res) => {
      this.aboutUsDetails = res;
    });
  }

  openConsoleExe() {
    //console.log("this functionality need to be implemented");
  }

  resetTestDataModel() {
    this.testDataFileName = "";
    this.testDataFile = undefined;
  }

  resetLocalizationModel() {
    this.localizationFileName = "";
    this.localizationFile = undefined;
  }

  resetSeleniumModel() {
    this.seleniumFileName = "";
    this.seleniumFile = undefined;
  }

  uploadLocalizationData(event: any) {
    //console.log(event);
    this.localizationFile = event.target.files[0];
    this.localizationFileName = this.localizationFile.name.substring(
      0,
      this.localizationFile.name.lastIndexOf(".")
    );
  }

  uploadSeleniumData(event: any) {
    //console.log(event);
    this.seleniumFile = event.target.files[0];
    this.seleniumFileName = this.seleniumFile.name.substring(
      0,
      this.seleniumFile.name.lastIndexOf(".")
    );
  }

  importSeleniumRecord() {
    //console.log("inside import selenium record", this.router.url);
    if (this.router.url.includes("TestSuit")) {
      this.project.getTestData().subscribe((res) => {
        //console.log(res);
      });

      this.selenuimTestId = this.router.url.substring(
        this.router.url.lastIndexOf("/") + 1,
        this.router.url.length
      );
      //console.log(this.selenuimTestId);

      // this.route.paramMap.subscribe((params)=>
      // {
      //   //console.log(params);
      //  //   this.selenuimProjectId =  params.get('pid');
      //   //  this.projectId = params.get('pid');
      //   this.selenuimTestId = params.get('tid');
      //     //console.log("inside test suite", this.projectId,this.selenuimTestId);
      // })
      //  this.importSelenium.nativeElement.click();
      this.showSeleniumModal = true;
    } else {
      this.toastrService.warning(
        "Please select a test suite to import selenium file"
      );
      this.showSeleniumModal = false;
      return;
    }
  }

  filterSuggestions()
  {
    if(this.globalSearch.trim().length === 0)
    {
        this.showSuggestion = false;
        return;
    }
   this.matchedSuggestions = this.searchSuggestions.filter((suggestion)=>
    {
      return suggestion.includes(this.globalSearch.trim());
    })
    this.showSuggestion = true;
  }

  searchText()
  {
    
    this.toastrService.clear();
    this.toastrService.success('Searching please wait..');
    this.project.searchProject(this.globalSearch).subscribe((res)=>
    {
      this.toastrService.clear();
      if(!res)
      {
        this.toastrService.info('Sorry, no matching result found');
        return;
      }

      let keys = Object.keys(res);
      this.searchResult = [];
      let searchResultBody = document.querySelector(".searchResultBody");
      keys.forEach((key)=>
      { 
        let obj = {}
        obj['key'] = key
        let array = res[key].split(">").filter((value)=>
        {
          return value != null && value.trim().length > 0;
        });
        obj['values'] = array;
        this.searchResult.push(obj);
      })
      this.showSearchResult = true;
    })
  }
  
  redirectUsingId(result)
  {
    let key = result.key;
    let resultLength =  result.values.length - 1;
    let lastResult = result.values[resultLength];
    let a = lastResult.lastIndexOf("(");
    let resultType = lastResult.slice(a, lastResult.length);
   
    let ids = key.split("+");
    console.log(ids, resultType);

    switch(resultType)
    {
        case "(P)":
          this.router.navigate([ "/module/" + ids[0] ]);
          break;
        case "(TSD)":
          this.router.navigate(["/suite/" + ids[0] + '/' + ids[1]]) ;
          break;
        case"(TS)":
        if(ids.length === 4)
        {
          this.router.navigate(["/test/TestSuit/" + ids[0] + '/' + ids[2] ]) ;
        }
        else
        {
          this.router.navigate(["/test/TestSuit/" + ids[0] + '/' + ids[1] ]) ;
        }
        break;
        case"(TC)":
        if(ids.length === 4)
        {
          this.router.navigate(["/test/TestStep/" + ids[0] + '/' + ids[2] + '/' + ids[3]]) ;
        }
        else
        {
          this.router.navigate(["/test/TestStep/" + ids[0] + '/' + ids[1] + '/' + ids[2]]) ;
        }
        break;
        default :
        break;
    }

  }

  selectSuggestion(suggestion)
  {
    this.globalSearch = suggestion;
    this.showSuggestion = false;
    this.searchText();
  }


  navigateHome(){
    this.testCase.setView(true)
    localStorage.removeItem('selectedProject');
    localStorage.removeItem('urlHistory');
    this.router.navigate([
      "/Dashboard"
    ])
  }
  getUrl() {
    if (this.currenturl.endsWith("Dashboard")) {
      //console.log('Dashboard');
    } else {
      //console.log('elseDashboard');
    }
  }
  navigatetestHistory(){
    this.router.navigate(['test/test-history/'+ this.projectId])
  }
 navigateLocatorHistory(){
  this.router.navigate(['project/history/'+ this.projectId])
 }

 openHuloopHelp() {
  const externalURL = 'https://huloop.ai/resources/beatblip-documentation/';
  window.open(externalURL, '_blank');
 }
openReleaseNotes(){
   const externalURL = 'http://huloop.ai/release-notes/';
  window.open(externalURL, '_blank');
}
 downloadHuloopWindowsAgent()
 {
  window.open(this.huloopAgentUrl, '_blank');
 }

 downloadHuloopWindowsConsole()
 {
  window.open(this.huloopAgentUrlConsole, '_blank');
 }

 downloadHuloopMacOSAgent()
 {
  window.open(this.huloopAgentUrlMac, '_blank');
 }

 downloadHuloopConsoleManagement()
 {
  window.open(this.huloopAgentUrlMacConsole, '_blank');
 }

 downloadWebRec()
 {
  window.open(this.recorderUrl, '_blank');
 }

 downloadDesktopRec()
 {
  window.open(this.desktopRecorderUrl, '_blank');
 }

 downloadAndroidMobileRec()
 {
  window.open(this.mobileRecorderAndroidUrl, '_blank');
 }

 downloadIosMobileRec()
 {
  window.open(this.mobileRecorderIosUrl, '_blank');
 }

 downloadDesktopDriver()
 {
  window.open(this.desktopDriverUrl, '_blank');
 }

  ngOnDestroy() {
    // this.cancelmodal.nativeElement.click();
    if (
      this.elRef.nativeElement.getRootNode().querySelector(".modal-backdrop")
    ) {
      this.elRef.nativeElement
        .getRootNode()
        .querySelector(".modal-backdrop")
        .classList.remove("in");
    }
    this.subscription.unsubscribe();
  }



}
